import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { SystemSection } from './components/SystemSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TargetAudienceSection } from './components/TargetAudienceSection';
import { TrustSection } from './components/TrustSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-black text-gray-200" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <SystemSection data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <TargetAudienceSection data-id="element-9" />
        <TrustSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <ClosingSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <WhatsAppButton data-id="element-15" />
      <SocialProofPopup data-id="element-16" />
    </div>;
}